import { render } from "./VODVideoDetailsForm.vue?vue&type=template&id=d69ca99c"
import script from "./VODVideoDetailsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./VODVideoDetailsForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/VODVideoDetailsForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d69ca99c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d69ca99c', __exports__)) {
    api.reload('d69ca99c', __exports__)
  }
  
  module.hot.accept("./VODVideoDetailsForm.vue?vue&type=template&id=d69ca99c", () => {
    api.rerender('d69ca99c', render)
  })

}


export default __exports__